import { formatISO } from "@workflows/std-js/datetime";
import { has } from "@workflows/std-js/object";
import { FilterInputType } from "@workflows/ui";
export function serializeFilter(input: FilterInputType | null): FilterInputType | null {
  if (!input) {
    return null;
  }
  const convert = (filter: FilterInputType): FilterInputType => {
    if ("and" in filter) {
      return {
        and: filter.and.map(convert)
      };
    } else if ("or" in filter) {
      return {
        or: filter.or.map(convert)
      };
    } else if (has(filter, "field")) {
      return {
        field: filter.field,
        op: filter.op,
        value: serializeFilterValue(filter.value),
        label: filter.label
      };
    } else {
      throw new Error("Invalid filter");
    }
  };
  const result = convert(input);
  return !has(result, "and") && !has(result, "or") ? {
    and: [result]
  } : result;
}
export function serializeFilterValue(value: any): string {
  if (typeof value === "string" || Array.isArray(value)) {
    return JSON.stringify(value);
  }
  if (value instanceof Date) {
    return formatISO(value, {
      representation: "date"
    });
  }
  return "";
}